import { render, staticRenderFns } from "./noticeQuery.vue?vue&type=template&id=cbaf16e8"
import script from "./noticeQuery.vue?vue&type=script&lang=js"
export * from "./noticeQuery.vue?vue&type=script&lang=js"
import style0 from "./noticeQuery.vue?vue&type=style&index=0&id=cbaf16e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports